import get from 'lodash.get';
import { config } from '@yola/ws-sdk';
import getIsB2C from './is-b2c';

const getAiChatURL = (rootState) => {
  const cfg = config.selectors.getConfig(rootState);

  if (getIsB2C(rootState)) {
    return get(cfg, 'common.ai-chat.url');
  }

  return get(cfg, 'common.ai-chat.wl_url');
};

export default getAiChatURL;
